import React from 'react';
import HeroSection from '../components/HeroSection';
import MediaSlider from '../components/MediaSlider';
import MissionSection from '../components/MissionSection';
import Timeline from '../components/Timeline';
import ValuesSection from '../components/ValuesSection';

const Home = () => {
  return (
    <main>
      <HeroSection />
      <MediaSlider />
      <MissionSection />
      <Timeline />
      <ValuesSection />
    </main>
  );
};

export default Home;

